import { computed } from 'vue';
import {
  SIGN_IN_ROUTE,
  SIGN_UP_ROUTE,
  EMAIL_CONFIRMATION_ROUTE,
  RESET_PASSWORD_ROUTE,
  DOWNLOAD_ROUTE,
  SIGN_IN_ROUTE_V2,
  SIGN_UP_ROUTE_V2,
  EMAIL_CONFIRMATION_ROUTE_V2,
  RESET_PASSWORD_ROUTE_V2,
  DOWNLOAD_ROUTE_V2,
} from '@/router/routes';
import { SessionStorageKey } from '@/shared/constants/storageKeys';

export const useRouteCheck = () => {
  const getCurrentVersion = () => {
    const version = sessionStorage.getItem(SessionStorageKey.VERSION);
    return parseInt(version, 10) || 1;
  };

  const currentVersion = computed(() => getCurrentVersion());

  const routesByVersion = {
    1: {
      signIn: SIGN_IN_ROUTE,
      signUp: SIGN_UP_ROUTE,
      emailConfirmation: EMAIL_CONFIRMATION_ROUTE,
      resetPassword: RESET_PASSWORD_ROUTE,
      download: DOWNLOAD_ROUTE,
    },
    2: {
      signIn: SIGN_IN_ROUTE_V2,
      signUp: SIGN_UP_ROUTE_V2,
      emailConfirmation: EMAIL_CONFIRMATION_ROUTE_V2,
      resetPassword: RESET_PASSWORD_ROUTE_V2,
      download: DOWNLOAD_ROUTE_V2,
    },
  };

  const getSignInRoute = () => routesByVersion[currentVersion.value]?.signIn || SIGN_IN_ROUTE;
  const getSignUpRoute = () => routesByVersion[currentVersion.value]?.signUp || SIGN_UP_ROUTE;
  const getEmailConfirmationRoute = () => 
    routesByVersion[currentVersion.value]?.emailConfirmation || EMAIL_CONFIRMATION_ROUTE;
  const getResetPasswordRoute = () => 
    routesByVersion[currentVersion.value]?.resetPassword || RESET_PASSWORD_ROUTE;
  const getDownloadRoute = () => routesByVersion[currentVersion.value]?.download || DOWNLOAD_ROUTE;

  return {
    currentVersion,
    getSignInRoute,
    getSignUpRoute,
    getEmailConfirmationRoute,
    getResetPasswordRoute,
    getDownloadRoute,
  };
};